import React from 'react';
import { IconProps } from './types';

export const DepositIcon = (props: IconProps) => {
  const { size = 24, color = 'currentColor', style = {} } = props;

  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.14282 9.14282L14.8571 14.8571'
        stroke='#DFF60D'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.8571 9.14282V14.8571H9.14282'
        stroke='#DFF60D'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
